import type { RoomView } from '@bm/shared';

/**
 * Leitet die Gesamtdauer der aktuellen Phase aus Start- und Endzeitpunkt ab.
 *
 * Für Phasen mit fester, nicht vom Host konfigurierbarer Dauer (Tie-Ansage,
 * Ergebnisanzeige) kennt der Client den Sekundenwert sonst nicht — er steht
 * bewusst nicht in den Settings (GDD §8: nur Spielregeln sind konfigurierbar).
 */
export function currentPhaseTotalSeconds(view: RoomView): number {
  if (view.phaseEndsAt === null) return 0;
  return Math.max(1, Math.round((view.phaseEndsAt - view.phaseStartedAt) / 1000));
}
